import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { useModal } from '../../../../../hooks/useModal'
import { SocietyInviteModal } from '../../SocietyInviteModal'
import { Icon, IconChoices } from '../../../../common/Icon'
import { Button, ButtonVariant } from '../../../../common/Button'
import { theme } from '../../../../../theme/theme'
import { societyQueries } from '../../../../../api/societies'
import { IPreApprovedList } from '../../../../../interfaces/models/societies.interfaces'

interface SocietyInviteBannerProps {
  preApproved: IPreApprovedList & { societyId: string }
}

export const SocietyInviteBanner = ({
  preApproved,
}: SocietyInviteBannerProps): JSX.Element | null => {
  const { translate } = useAppTranslation()
  const {
    show: showSocietyInviteModal,
    open: openSocietyInviteModal,
    close: closeSocietyInviteModal,
  } = useModal()
  const { data: society } = useQuery(
    societyQueries.getSociety(preApproved.societyId)
  )

  return (
    <>
      <div
        className="flex w-full items-center justify-between bg-almostBrandGreen 
        px-4 py-4 md:h-16 md:px-20"
      >
        <Icon
          size={40}
          icon={IconChoices.INFORMATION}
          color={theme.colors.white}
          className="hidden md:block"
        />
        <p style={theme.textVariants.baseBold}>
          {translate('societyInviteBanner.invited', {
            societyName: society?.name,
          })}
        </p>
        <Button
          size="sm"
          variant={ButtonVariant.PRIMARY}
          onClick={openSocietyInviteModal}
          label={translate('societyInviteBanner.details')}
        />
      </div>
      <SocietyInviteModal
        preApproved={preApproved}
        show={showSocietyInviteModal}
        close={closeSocietyInviteModal}
      />
    </>
  )
}
